import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { SvgContainer } from './styled.ts';

export type Bbfc12AProps = {
  height?: number;
  sx?: SystemStyleObject<Theme>;
  width?: number;
};

export const Bbfc12A = ({ height = 35, sx, width = 35 }: Bbfc12AProps) => (
  <SvgContainer height={height} sx={sx} viewBox="0 0 92.604 92.598" width={width} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="a">
        <path d="M208.063 273.902h55.984v55.985h-55.985Zm0 0" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#a)"
      style={{ opacity: 1, stopOpacity: 1 }}
      transform="matrix(1.6541 0 0 1.6541 -344.158 -453.064)"
    >
      <path
        d="M236.055 328.902c-14.918 0-27.008-12.093-27.008-27.011 0-14.914 12.09-27.008 27.008-27.008s27.011 12.094 27.011 27.008c0 14.918-12.093 27.011-27.011 27.011m0-55c-15.461 0-27.992 12.532-27.992 27.989 0 15.46 12.53 27.992 27.992 27.992 15.46 0 27.992-12.531 27.992-27.992 0-15.457-12.531-27.989-27.992-27.989"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d="M236.055 326.445c-13.563 0-24.555-10.992-24.555-24.55 0-13.563 10.992-24.555 24.555-24.555 13.562 0 24.554 10.992 24.554 24.555 0 13.558-10.992 24.55-24.554 24.55m0-51.562c-14.918 0-27.008 12.094-27.008 27.012 0 14.914 12.09 27.007 27.008 27.007s27.011-12.093 27.011-27.007c0-14.918-12.093-27.012-27.011-27.012"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -344.158 -453.064)"
    />
    <path
      d="M236.055 277.34c-13.563 0-24.555 10.992-24.555 24.55 0 13.563 10.992 24.555 24.555 24.555 13.562 0 24.554-10.992 24.554-24.554 0-13.559-10.992-24.551-24.554-24.551"
      style={{
        fill: '#ee7817',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -344.158 -453.064)"
    />
    <path
      d="M222.164 291.762v19.644h-3.578v-11.234c0-1.863 0-2.414-1.606-2.414h-3.199v-2.242h.38c1.831-.032 4.308-.059 5.093-3.754zM238.75 308.383v3.027h-13.36v-2.824c2.505-1.719 4.977-4.074 6.141-5.27 1.078-1.105 2.883-3 2.883-5.59 0-1.511-.758-2.937-2.59-2.937-2.883 0-2.797 3.14-2.765 4.54l-3.668-.321c0-2.766.902-4.54 1.66-5.445 1.074-1.25 2.937-2.122 5.062-2.122 3.727 0 6.317 2.414 6.317 6.141 0 3.172-1.95 5.441-4.102 7.395-.437.378-3.058 2.59-4.164 3.406zM252.332 307.582h-7.348l-1.136 3.828h-3.91l6.601-19.57h4.156l6.68 19.57h-3.91zm-.973-3.187-2.687-9.008-2.715 9.008zm0 0"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -344.158 -453.064)"
    />
  </SvgContainer>
);
